import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import { RESOURCE_TYPES } from '../../constants';

import ContentGridItem from './ContentGridItem';

const propTypes = {

	/**
	 * The parent content resource.
	 */
	resource: PropTypes.shape({

		/**
		 * The resource ID.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The resource type.
		 */
		type: PropTypes.oneOf([
			RESOURCE_TYPES.PAGE,
			RESOURCE_TYPES.MODULE,
			RESOURCE_TYPES.SUBMODULE,
			RESOURCE_TYPES.SUBMODULE_CONTENT,
		]).isRequired,

		/**
		 * The resource title.
		 */
		title: PropTypes.string,

		/**
		 * The resource slug.
		 */
		slug: PropTypes.string,

		/**
		 * The children resources (if any).
		 */
		children: PropTypes.arrayOf(PropTypes.shape({

			/**
			 * The child resource ID.
			 */
			id: PropTypes.string,

		})),

	}).isRequired,

	/**
	 * The rows of child resources to render.
	 */
	gridRows: PropTypes.arrayOf(

		PropTypes.arrayOf(PropTypes.shape({

			/**
			 * The resource ID.
			 */
			id: PropTypes.string.isRequired,

		})).isRequired,

	).isRequired,

};

const ContentGridStudent = (props) => {

	const {
		resource,
		gridRows,
		...restProps
	} = props;

	return gridRows.map((row) => (
		<Row
			key={row.map((child) => child.id).join('-')}
			className="row-of-content-resources">
			{row.map((child) => (
				<Col
					key={child.id}
					sm={child.width}
					xs="12"
					className="content-container">
					<ContentGridItem
						id={child.id}
						resource={child}
						parent={resource}
						{...restProps} />
				</Col>
			))}
		</Row>
	));

};

ContentGridStudent.propTypes = propTypes;

export default ContentGridStudent;
